<script setup>
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 19">
        <path
            d="M7 18.45C4.98333 18.2 3.3125 17.3208 1.9875 15.8125C0.6625 14.3042 0 12.5333 0 10.5C0 9.4 0.216667 8.34583 0.65 7.3375C1.08333 6.32917 1.7 5.45 2.5 4.7L3.925 6.125C3.29167 6.69167 2.8125 7.35 2.4875 8.1C2.1625 8.85 2 9.65 2 10.5C2 11.9667 2.46667 13.2625 3.4 14.3875C4.33333 15.5125 5.53333 16.2 7 16.45V18.45ZM9 18.45V16.45C10.45 16.1833 11.6458 15.4917 12.5875 14.375C13.5292 13.2583 14 11.9667 14 10.5C14 8.83333 13.4167 7.41667 12.25 6.25C11.0833 5.08333 9.66667 4.5 8 4.5H7.925L9.025 5.6L7.625 7L4.125 3.5L7.625 0L9.025 1.4L7.925 2.5H8C10.2333 2.5 12.125 3.275 13.675 4.825C15.225 6.375 16 8.26667 16 10.5C16 12.5167 15.3375 14.2792 14.0125 15.7875C12.6875 17.2958 11.0167 18.1833 9 18.45Z" />
    </svg>
</template>

<style lang="scss" scoped></style>
